







































































































































import PatientFormComponent from "@/components/Patient/PatientForm/PatientFormComponent";
export default PatientFormComponent;
